import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66da5264"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-list"]
const _hoisted_2 = { class: "table-responsive scrollbar" }
const _hoisted_3 = { class: "table table-sm fs--1 mb-0 table-hover" }
const _hoisted_4 = { class: "bg-white text-900" }
const _hoisted_5 = { class: "text-props" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "col-sm-4"
}, null, -1))
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "flex-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "d-none text-900 fw-bold my-1 d-inline-block text-truncate align-items-center aling-middle ms-1",
  style: {"max-width":"250px"}
}, " fdfnhrjebghrejgbehjrfbhejfbhejrbghjreb ", -1))
const _hoisted_15 = { class: "mb-1 text-500 fw-medium text-nowrap" }
const _hoisted_16 = ["textContent"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "/", -1))
const _hoisted_18 = ["textContent"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "/", -1))
const _hoisted_20 = ["textContent"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "/", -1))
const _hoisted_22 = ["textContent"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "/", -1))
const _hoisted_24 = ["textContent"]
const _hoisted_25 = ["textContent"]
const _hoisted_26 = { class: "liked align-middle white-space-nowrap" }
const _hoisted_27 = { class: "align-middle" }
const _hoisted_28 = ["textContent"]
const _hoisted_29 = {
  class: "align-middle text-center white-space-nowrap",
  "data-sort": "add",
  style: {"max-width":"85px"}
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "card-footer bg-light d-flex py-2" }
const _hoisted_33 = { class: "col d-flex justify-content-start" }
const _hoisted_34 = { class: "mr-2" }
const _hoisted_35 = { class: "col d-flex justify-content-center" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-falcon-default me-1 d-none",
  type: "button",
  title: "Previous",
  "data-list-pagination": "prev"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-chevron-left" })
], -1))
const _hoisted_37 = { class: "pagination mb-0" }
const _hoisted_38 = ["onClick", "data-i", "textContent"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-falcon-default ms-1 d-none",
  type: "button",
  title: "Next",
  "data-list-pagination": "next"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-chevron-right" })
], -1))
const _hoisted_40 = { class: "col d-flex justify-content-end" }
const _hoisted_41 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Rating = _resolveComponent("Rating")!
  const _component_ModalExerciseDetails = _resolveComponent("ModalExerciseDetails")!
  const _component_ModalAssignExercisesToClassgroups = _resolveComponent("ModalAssignExercisesToClassgroups")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "card-body px-0 py-0",
      id: "contentExercisesTable",
      "data-list": JSON.stringify(_ctx.dataListOptions)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", _hoisted_4, [
            _createElementVNode("tr", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("th", {
                scope: "col",
                class: "pr-1 align-middle white-space-nowrap",
                "data-sort": "assigned",
                textContent: _toDisplayString('Assigned')
              }, null, 8, _hoisted_7),
              _createElementVNode("th", {
                scope: "col",
                class: "pr-1 align-middle white-space-nowrap ps-3",
                "data-sort": "liked",
                textContent: _toDisplayString('Liked')
              }, null, 8, _hoisted_8),
              _createElementVNode("th", {
                scope: "col",
                class: "pr-1 align-middle white-space-nowrap",
                "data-sort": "myNotes",
                textContent: _toDisplayString('My Notes')
              }, null, 8, _hoisted_9),
              _createElementVNode("th", {
                class: "pr-1 align-middle text-center white-space-nowrap",
                "data-sort": "Assign",
                textContent: _toDisplayString('Assign')
              }, null, 8, _hoisted_10)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exercises, (exercise, idx) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "btn-reveal-trigger",
                key: idx
              }, [
                _createElementVNode("td", {
                  class: "d-flex align-items-center align-middle position-relative",
                  onClick: ($event: any) => (_ctx.showExerciseDetails(exercise, idx))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("p", _hoisted_15, [
                      _createElementVNode("span", {
                        class: "difficult white-space-nowrap px-1",
                        textContent: _toDisplayString(exercise.difficult)
                      }, null, 8, _hoisted_16),
                      _hoisted_17,
                      _createElementVNode("span", {
                        class: "exerciseType px-2",
                        textContent: _toDisplayString(exercise.type),
                        "data-bs-toggle": "popover",
                        "data-bs-placement": "bottom",
                        "data-bs-trigger": "focus",
                        "data-bs-content": "Bottom Popover"
                      }, null, 8, _hoisted_18),
                      _hoisted_19,
                      _createElementVNode("span", {
                        class: "level white-space-nowrap px-1",
                        textContent: _toDisplayString(exercise.level)
                      }, null, 8, _hoisted_20),
                      _hoisted_21,
                      _createElementVNode("span", {
                        class: "gender text-center white-space-nowrap px-1",
                        textContent: _toDisplayString(exercise.gender)
                      }, null, 8, _hoisted_22),
                      _hoisted_23,
                      _createElementVNode("span", {
                        class: "accent white-space-nowrap px-1",
                        textContent: _toDisplayString(exercise.accent)
                      }, null, 8, _hoisted_24)
                    ])
                  ])
                ], 8, _hoisted_12),
                _createElementVNode("td", {
                  class: "align-middle white-space-nowrap",
                  textContent: _toDisplayString(exercise.assigned ? 'Yes' : 'No')
                }, null, 8, _hoisted_25),
                _createElementVNode("td", _hoisted_26, [
                  _createVNode(_component_Rating, {
                    maxValue: 5,
                    value: exercise.liked
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("td", _hoisted_27, [
                  _createElementVNode("span", {
                    class: "ms-3 badge rounded-pill-lg badge-soft-success",
                    textContent: _toDisplayString(exercise.notes.length)
                  }, null, 8, _hoisted_28)
                ]),
                _createElementVNode("td", _hoisted_29, [
                  (_ctx.exercisesToAssign.indexOf(exercise.id) == -1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-falcon-primary me-1 mb-1 btn-table-header",
                        type: "button",
                        onClick: ($event: any) => (_ctx.addExerciseToClassgroup(exercise.id))
                      }, " Choose + ", 8, _hoisted_30))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-falcon-primary me-1 mb-1 btn-table-header",
                        type: "button",
                        onClick: ($event: any) => (_ctx.removeExerciseFromClassgroup(exercise.id))
                      }, " Remove - ", 8, _hoisted_31))
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("span", _hoisted_34, "Ready to be added: " + _toDisplayString(_ctx.exercisesToAssign.length), 1)
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("ul", _hoisted_37, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass({ active: page.active }),
                key: page.number
              }, [
                _createElementVNode("a", {
                  class: "page",
                  onClick: ($event: any) => (_ctx.changePage(page.number)),
                  "data-i": page.number,
                  "data-page": "8",
                  textContent: _toDisplayString(page.number)
                }, null, 8, _hoisted_38)
              ], 2))
            }), 128))
          ]),
          _hoisted_39
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-assign-exercises",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showModalAssignExercisesToGlassgroups && _ctx.showModalAssignExercisesToGlassgroups(...args))),
            disabled: _ctx.exercisesToAssign.length == 0
          }, " Add selected exercises to a Classgroup ", 8, _hoisted_41)
        ])
      ])
    ], 8, _hoisted_1),
    _createVNode(_component_ModalExerciseDetails, {
      id: "exercise-details-modal",
      ref: "modalExerciseDetails",
      show: _ctx.selectedExercise != null,
      exercise: _ctx.selectedExercise,
      first: _ctx.selectedExerciseIdx == 0,
      last: _ctx.selectedExerciseIdx == _ctx.exercises.length - 1,
      added: _ctx.exercisesToAssign.indexOf(_ctx.selectedExercise?.id) != -1,
      languageFromId: _ctx.languageFromId,
      languageToId: _ctx.languageToId,
      onAdd: _ctx.addExerciseToClassgroup,
      onRemove: _ctx.removeExerciseFromClassgroup,
      onNext: _ctx.showNextExerciseDetails,
      onPrev: _ctx.showPrevExerciseDetails,
      onClose: _ctx.closeModalExerciseDetails
    }, null, 8, ["show", "exercise", "first", "last", "added", "languageFromId", "languageToId", "onAdd", "onRemove", "onNext", "onPrev", "onClose"]),
    _createVNode(_component_ModalAssignExercisesToClassgroups, {
      id: "exercise-assign-to-classgroups-modal",
      ref: "modalAssignExerciseToClassgroups",
      "class-groups": _ctx.classGroups,
      "class-group": _ctx.classGroup,
      onAssign: _ctx.addExercisesToClassgroup,
      onClose: _ctx.closeModalAssignExercisesToGlassgroups
    }, null, 8, ["class-groups", "class-group", "onAssign", "onClose"])
  ], 64))
}